import { APICore } from "./apiCore";

const api = new APICore()

function getContratos(params:any): any{
    const baseUrl = "/contratos"
    return api.get(baseUrl,params)
}

function getContrato(id:String): any{
    const baseUrl = `/contratos/${id}`
    return api.get(baseUrl,{})
}

function addContrato(params:any):any{
    const baseUrl = "/contratos"
    return api.create(baseUrl,params)
}

function updateContrato(params:any): any{
    const baseUrl = "/contratos"
    return api.update(baseUrl,params)
}

function deleteContrato(params:any): any{
    // console.log(params)
    const baseUrl = "/contratos"
    return api.delete(baseUrl,params)
}

export {getContratos,getContrato,addContrato,updateContrato,deleteContrato}